import Tabs from "../../ui/Tabs/Tabs";
import Page from "../Page";
import styles from "./Keywords.module.scss";
import SearchByKeyword from "./SearchByKeyword/SearchByKeyword";
import SearchByURL from "./SearchByURL/SearchByURL";
import SearchByCompetitor from "./SearchByCompetitor/SearchByCompetitor";
import { Coins } from "../../ui/Icon/Icon";
import Button from "../../ui/Button/Button";
import useUser from "../../providers/UserProvider/useUser";
import KeywordUsagePopoverContent from "./KeywordUsagePopoverContent";
import { useDisclosure } from "../../ui/util/useDisclosure";
import PurchaseCreditsModal from "../Settings/Billing/CreditsCard/PurchaseCreditsModal/PurchaseCreditsModal";
import { useNavigate, useParams } from "react-router-dom";
import urls from "../../routes";
import KeywordRecommendations from "./KeywordRecommendations/KeywordRecommendations";

function Keywords() {
  const [purchaseCreditsModalOpened, purchaseCreditsModal] = useDisclosure();
  const { keywordQueryCreditsRemaining } = useUser();
  const navigate = useNavigate();
  const { tabValue } = useParams();

  return (
    <Page
      fullHeight
      title="Keywords"
      documentTitle="Keywords"
      buttons={[
        {
          content: (
            <KeywordUsagePopoverContent
              openCreditsModal={purchaseCreditsModal.open}
            />
          ),
          side: "bottom",
          align: "end",
          children: (
            <Button
              size="small"
              variant="outline"
              leftIcon={<Coins size="small" />}
            >
              {keywordQueryCreditsRemaining}
            </Button>
          ),
          type: "popover",
        },
      ]}
    >
      <Tabs
        value={tabValue}
        onValueChange={(value) => navigate(`${urls.keywords.root}/${value}`)}
        className={styles.container}
        tabs={[
          {
            id: "recommendations",
            label: "Recommendations",
            content: <KeywordRecommendations />,
          },
          {
            id: "search-by-keyword",
            label: "Search by keyword",
            content: <SearchByKeyword />,
          },
          {
            id: "search-by-url",
            label: "Search by URL",
            content: <SearchByURL />,
          },
          {
            id: "competitor-gaps",
            label: "Search competitor gaps",
            content: <SearchByCompetitor />,
          },
        ]}
      />

      <PurchaseCreditsModal
        defaultValue="keywords"
        isOpen={purchaseCreditsModalOpened}
        onClose={purchaseCreditsModal.close}
      />
    </Page>
  );
}

export default Keywords;
